
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { BAIconsMixin } from '@/mixins';
import { TeamModel } from '@/models/team';
import { CalendarApi, CalendarEventsApi } from '@/api/CalendarApi';
import { CalendarEventModel } from '@/models/calendar/CalendarEventModel';

interface StatRow { id: string; name: string; isStaff: boolean; going: number; total: number; noReply: number; responseRate: number; }

@Component
export default class TeamAttendanceStats extends Mixins(BAIconsMixin) {
	@Prop({ required: true }) team: TeamModel;

	events: CalendarEventModel[] = [];
	loading = false;
	error = false;
	// It has its own tab now, so open it by default; the toggle stays for a quick collapse.
	expandedAttendance = true;

	mounted(): void { this.load(); }

	async load(): Promise<void> {
		if (!this.team || !this.team.id) return;
		this.loading = true;
		this.error = false;
		try {
			const calendarApi = new CalendarApi('team', this.team.id);
			const calendars = await calendarApi.findAllWithAccess();
			if (calendars && calendars.length) {
				const eventsApi = new CalendarEventsApi('team', this.team.id, calendars[0].id);
				this.events = await eventsApi.findAllWithAccess();
			} else {
				this.events = [];
			}
		} catch (e) {
			this.error = true;
			// eslint-disable-next-line no-console
			console.error('Failed to load attendance stats', e);
		} finally {
			this.loading = false;
		}
	}

	get Rows(): StatRow[] {
		const byMember: Record<string, { name: string; isStaff: boolean; going: number; total: number; noReply: number }> = {};
		for (const ev of this.events || []) {
			for (const p of (ev.participants || [])) {
				const memberId = p.coachId || p.athleteId;
				if (!memberId) continue;
				if (!byMember[memberId]) byMember[memberId] = { name: p.name, isStaff: !!p.coachId, going: 0, total: 0, noReply: 0 };
				const rec = byMember[memberId];
				rec.total++;
				if (p.rsvp === 'Yes') rec.going++;
				if (!p.rsvp || p.rsvp === 'None') rec.noReply++;
			}
		}
		return Object.keys(byMember).map(id => {
			const r = byMember[id];
			const responded = r.total - r.noReply;
			return {
				id, name: r.name, isStaff: r.isStaff, going: r.going, total: r.total, noReply: r.noReply,
				responseRate: r.total ? Math.round((responded / r.total) * 100) : 0,
			};
		}).sort((a, b) => (Number(a.isStaff) - Number(b.isStaff)) || (b.going - a.going));
	}
}
